export default __webpack_public_path__ + "static/media/product-05 (1).d5c066e6.jpg";